import createIcon from '../../createIcon';

/**
 * @component @name SentimentSatisfiedAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxMUMxNi4zMjg0IDExIDE3IDEwLjMyODQgMTcgOS41QzE3IDguNjcxNTcgMTYuMzI4NCA4IDE1LjUgOEMxNC42NzE2IDggMTQgOC42NzE1NyAxNCA5LjVDMTQgMTAuMzI4NCAxNC42NzE2IDExIDE1LjUgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC41IDExQzkuMzI4NDMgMTEgMTAgMTAuMzI4NCAxMCA5LjVDMTAgOC42NzE1NyA5LjMyODQzIDggOC41IDhDNy42NzE1NyA4IDcgOC42NzE1NyA3IDkuNUM3IDEwLjMyODQgNy42NzE1NyAxMSA4LjUgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuNSAxMUMxNi4zMjg0IDExIDE3IDEwLjMyODQgMTcgOS41QzE3IDguNjcxNTcgMTYuMzI4NCA4IDE1LjUgOEMxNC42NzE2IDggMTQgOC42NzE1NyAxNCA5LjVDMTQgMTAuMzI4NCAxNC42NzE2IDExIDE1LjUgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC41IDExQzkuMzI4NDMgMTEgMTAgMTAuMzI4NCAxMCA5LjVDMTAgOC42NzE1NyA5LjMyODQzIDggOC41IDhDNy42NzE1NyA4IDcgOC42NzE1NyA3IDkuNUM3IDEwLjMyODQgNy42NzE1NyAxMSA4LjUgMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ3IDIyIDExLjk5IDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMS45OSAyWk0xMiAyMEM3LjU4IDIwIDQgMTYuNDIgNCAxMkM0IDcuNTggNy41OCA0IDEyIDRDMTYuNDIgNCAyMCA3LjU4IDIwIDEyQzIwIDE2LjQyIDE2LjQyIDIwIDEyIDIwWk0xMiAxNy41QzE0LjMzIDE3LjUgMTYuMzIgMTYuMDUgMTcuMTIgMTRIMTUuNDVDMTQuNzYgMTUuMTkgMTMuNDggMTYgMTIgMTZDMTAuNTIgMTYgOS4yNSAxNS4xOSA4LjU1IDE0SDYuODhDNy42OCAxNi4wNSA5LjY3IDE3LjUgMTIgMTcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SentimentSatisfiedAlt = createIcon('SentimentSatisfiedAlt', [
  [
    'path',
    {
      d: 'M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z',
      key: 'hr45rr',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z',
      key: '1i0urh',
    },
  ],
  [
    'path',
    {
      d: 'M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z',
      key: 'hr45rr',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z',
      key: '1i0urh',
    },
  ],
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12 17.5C14.33 17.5 16.32 16.05 17.12 14H15.45C14.76 15.19 13.48 16 12 16C10.52 16 9.25 15.19 8.55 14H6.88C7.68 16.05 9.67 17.5 12 17.5Z',
      key: '9l5644',
    },
  ],
]);

export default SentimentSatisfiedAlt;
